import React, { useMemo } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateTimePicker from '@/components/Form/DateTimePicker'
import { Dayjs } from 'dayjs'
import {
    MEETING_TICKET_KEY,
    TICKET_TYPE_GROUP_MEETING,
} from '@/modules/Ticket/constants'

interface Props {
    control: Control<any>
    onChange?: (value: Dayjs | null) => void
    ticketTypeGroup?: string
    ticketTypeKey?: string
}

/**
 * TG khách hàng yêu cầu hỗ trợ/ gặp sự cố
 * @param control - Control<any>
 * @param onChange - Callback khi thay đổi giá trị
 * @returns React.ReactNode
 */
const TicketRequestedAt: React.FC<Props> = ({
    control,
    onChange,
    ticketTypeGroup,
    ticketTypeKey,
}) => {
    const { t } = useTranslation()

    const label = useMemo(() => {
        if (ticketTypeGroup === TICKET_TYPE_GROUP_MEETING) {
            return ticketTypeKey === MEETING_TICKET_KEY
                ? t('ticket-meeting-online-time')
                : t('ticket-meeting-customer-time')
        }
        return t('ticket-request-at')
    }, [ticketTypeGroup, ticketTypeKey, t])

    return (
        <>
            <DateTimePicker
                control={control}
                name="ticket_requested_at"
                label={label}
                required
                onChange={onChange}
            />
        </>
    )
}

export default TicketRequestedAt
